import moment from "moment";
import ProgressBar from "@ramonak/react-progress-bar";
const Timelines = (props) => {
    return (
        <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="card card-radius">
                <div className="header card-header custum-bg-warning rounded">
                    <h2 className="text-white">Timeline</h2>
                </div>
                <div className="body card-body-shadow">
                    <div className="header">
                        <div className="row">
                            <div className="col-md-6 col-lg-6 col-sm-12">
                                <h6><strong>Start Date </strong></h6>
                                <span style={{fontSize:'14px', fontWeight:700}}>{props?.project?.project_start_date && moment(props?.project?.project_start_date).format("DD/MM/YYYY")}</span>
                            </div>
                            <div className="col-md-6 col-lg-6 col-sm-12 text-right">
                                <h6><strong> Due Date</strong></h6>
                                <span style={{fontSize:'14px', fontWeight:700}}>{props?.project?.project_end_date && moment(props?.project?.project_end_date).format("DD/MM/YYYY")}</span>
                            </div>
                        </div>
                    </div>
                    {/* <div className="progress progress-sm">
                         <div className="progress-bar custum-bg-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{"width": "89%"}}>
                            <span className="sr-only">60% Complete</span>
                        </div>
                    </div> */}

                    <ProgressBar completed={props?.project?.completePercent || 0} bgColor="#FA7A13" className="pb-3"/>

                    <div className="row">
                        <div className="col-sm-4">
                            <div className="card timeline-card">
                            <div className="card-body">
                                <h6 className="card-title text-center"><strong>Total Days</strong></h6>
                                <h4 className="card-text text-center"><strong>{props?.project?.totalDays || 0}</strong></h4>
                            </div>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="card timeline-card">
                            <div className="card-body">
                                <h6 className="card-title text-center"><strong>Days Remaining</strong></h6>
                                <h4 className="card-text text-center"><strong>{props?.project?.remainingDays || 0}</strong></h4>
                            </div>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="card timeline-card">
                            <div className="card-body">
                                <h6 className="card-title text-center"><strong>% Complete</strong></h6>
                                <h4 className="card-text text-center"><strong>{props?.project?.completePercent + '%' || '0 %'}</strong></h4>
                            </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    );
}
export default Timelines;